import React from "react";
import { ReadOutlined } from "@ant-design/icons";
import { SbButton, SbTooltip, SbBetaTag } from "uiCore";
import { TooltipTriggerStyled } from "uiCore/SbTooltip/SbTooltip.styles";

// Shown on every match-score page (Role Detail's candidate view, the
// employee skill-gap detail view). Learning Catalyst itself is still a
// placeholder page (no real course-recommendation data yet), so the button
// is disabled rather than linking through to it — wrapping the disabled
// SbButton in TooltipTriggerStyled keeps the tooltip working, since a
// disabled native button suppresses hover events.
const LearningCatalystLink = () => (
  <SbTooltip content="Learning Catalyst is coming soon.">
    <TooltipTriggerStyled>
      <SbButton buttonType="secondary" icon={<ReadOutlined />} disabled>
        View Learning Courses
        <SbBetaTag label="Coming soon" />
      </SbButton>
    </TooltipTriggerStyled>
  </SbTooltip>
);

export default LearningCatalystLink;
